import { useState, useRef, useEffect } from 'react'
import L from 'leaflet'

import ReactLeafletDriftMarker from 'react-leaflet-drift-marker'
import rig from '../images/board_i2.png'
import noRig from '../assets/no_board.png'
import { kStart, kPause, kStop } from '../assets/assets_functions'
import { Tooltip } from 'react-leaflet'

const MovingMarker = ({
  currentPos,
  movePos,
  move,
  moveSpeed,
  handleMoveEnded,
  handlePosChanged,
}) => {
  require('leaflet-rotatedmarker')

  const myInterval = useRef(null)
  const startPos = useRef(0)
  const step = useRef(1)
  const myMarker = useRef(null)
  const my_duration = useRef(null)
  const [mPosition, setmPosition] = useState(movePos[0].pos)

  const wIcon = L.icon({
    iconUrl: rig,
    iconAnchor: [5, 10],
  })

  const noIcon = L.icon({
    iconUrl: noRig,
    iconAnchor: [5, 10],
  })

  const locDuration = 1000 / moveSpeed

  useEffect(() => {
    const newPosition = () => {
      if (
        myMarker.current !== undefined &&
        myMarker.current != null &&
        step.current + 1 < movePos.length
      ) {
        myMarker.current.setRotationAngle(movePos[step.current + 1].angle)
        setmPosition(movePos[step.current + 1].pos)
        handlePosChanged(step.current)
      } else {
        clearInterval(myInterval.current)
        step.current = 0
        myInterval.current = null
        handleMoveEnded()
      }
      step.current += 1
    }
    switch (move) {
      case kStart:
        if (myInterval.current === null) {
          myInterval.current = setInterval(newPosition, locDuration)
        }
        break
      case kPause:
        if (myInterval.current !== null) {
          clearInterval(myInterval.current)
          myInterval.current = null
        }
        break
      case kStop:
        if (myInterval.current !== null) {
          clearInterval(myInterval.current)
          myInterval.current = null
        }
        step.current = 0
        newPosition()
        break
      default:
        return null
    }
  }, [move, locDuration])

  const newPosition = () => {
    if (
      myMarker.current !== undefined &&
      myMarker.current != null &&
      step.current + 1 < movePos.length
    ) {
      myMarker.current.setRotationAngle(movePos[step.current + 1].angle)
      setmPosition(movePos[step.current + 1].pos)
      handlePosChanged(step.current)
    } else {
      clearInterval(myInterval.current)
      step.current = 0
      myInterval.current = null
      handleMoveEnded()
    }
    step.current += 1
  }

  if (currentPos !== startPos.current) {
    step.current = currentPos
    startPos.current = currentPos
  }
  if (my_duration.current !== locDuration) {
    if (myInterval.current !== null) {
      clearInterval(myInterval.current)
      myInterval.current = setInterval(newPosition, locDuration)
    }
  }

  return (
    <>
      <ReactLeafletDriftMarker
        ref={myMarker}
        position={mPosition}
        duration={locDuration}
        keepAtCenter={false}
        icon={move === kStop ? noIcon : wIcon}
      >
        {movePos[step.current].speed > 0 && (
          <Tooltip
            permanent
            sticky
            opacity={0.9}
            offset={L.point(0, 20)}
            direction={'bottom'}
          >
            {movePos[step.current].speed + ' knts'}
          </Tooltip>
        )}
      </ReactLeafletDriftMarker>
    </>
  )
}

export default MovingMarker
